/**
 * Cuantos productos destacados muestra la portada (ADM-06).
 *
 * El numero lo elige el cliente, entre uno y el techo que manda el servidor
 * (`topeDestacados`). Bajarlo no desmarca a nadie: los que sobran quedan en la
 * lista de abajo como "fuera de la portada".
 */
import { useState } from 'react';
import type { FormEvent } from 'react';

import type { ConfiguracionPortada } from '@elcarpintero/compartido';

import { guardarMaximoDestacados } from '../../servicios/portada.servicio';
import { mensajeDe } from '../../utilidades/mensaje-error';
import { Icono } from '../comunes/Icono';

interface MaximoDestacadosProps {
  configuracion: ConfiguracionPortada;
  alGuardar: (configuracion: ConfiguracionPortada) => void;
  alFallar: (mensaje: string | null) => void;
}

export function MaximoDestacados({ configuracion, alGuardar, alFallar }: MaximoDestacadosProps) {
  const { maximoDestacados, topeDestacados } = configuracion;
  const [valor, setValor] = useState(String(maximoDestacados));
  const [guardando, setGuardando] = useState(false);
  const [guardado, setGuardado] = useState(false);

  const elegido = Number(valor);
  const valido = Number.isInteger(elegido) && elegido >= 1 && elegido <= topeDestacados;
  const cambio = elegido !== maximoDestacados;

  async function alEnviar(evento: FormEvent<HTMLFormElement>): Promise<void> {
    evento.preventDefault();
    if (!valido) return;

    setGuardando(true);
    setGuardado(false);
    alFallar(null);

    try {
      alGuardar(await guardarMaximoDestacados(elegido));
      setGuardado(true);
    } catch (fallo) {
      alFallar(mensajeDe(fallo));
    } finally {
      setGuardando(false);
    }
  }

  return (
    <form
      className="maximo-destacados"
      onSubmit={(evento) => {
        void alEnviar(evento);
      }}
    >
      <label htmlFor="maximo-destacados" className="filtro-et">
        Cuántos muestra la portada
      </label>
      <div className="admin-acciones">
        <input
          id="maximo-destacados"
          className={cambio ? 'entrada entrada-numero cambiado' : 'entrada entrada-numero'}
          type="number"
          inputMode="numeric"
          min={1}
          max={topeDestacados}
          step={1}
          required
          value={valor}
          onChange={(evento) => {
            setValor(evento.target.value);
            setGuardado(false);
          }}
        />
        {cambio ? (
          <button type="submit" className="btn btn-primario btn-sm" disabled={guardando || !valido}>
            {guardando ? 'Guardando…' : 'Guardar'}
          </button>
        ) : null}
        {!cambio && guardado ? (
          <span className="etiqueta-ok" role="status">
            <Icono nombre="check" />
            Guardado
          </span>
        ) : null}
      </div>
      <p className="campo-ayuda">
        Entre 1 y {topeDestacados}. También es cuántos se pueden marcar.
      </p>
    </form>
  );
}
